/*
 * GRAVURZEILE 23.09.2026 - Varianten-Bildchen (Swatch King) auf Produktkarten
 * auf EINE Zeile begrenzen: passen nicht alle hinein, bleiben die ersten
 * sichtbar und ein "+N" zeigt, wie viele es noch gibt. Die Karten bleiben so
 * gleich hoch. Stil: assets/mf-einheit.css (Nachtrag 23.09.2026).
 * Die App baut die Bildchen erst nach dem Laden ein - deshalb ein Beobachter.
 *
 * Nachtrag 23.09.2026 (Vorab-Reihe): Dasselbe gilt fuer die Reihe aus
 * snippets/gz-swatch-vorab.liquid, die schon im HTML steht. Sie wird sofort
 * beim Start gekuerzt. Setzt die App ihre Reihe ein, wird genau diese Reihe
 * noch im selben Durchgang gekuerzt (vor dem naechsten Bild), damit sie nicht
 * kurz ohne "+N" erscheint. Der verzoegerte Gesamtlauf bleibt als Netz.
 *
 * Nachtrag 23.09.2026 (Hinweis von Mitarbeitern): Die Vorab-Reihe ist jetzt
 * bedienbar wie die der App (gemessen, was die App tut):
 * - Ueberfahren: grosses Variantenbild als Kartenbild (und das naechste
 *   Produktbild als zweites Bild), beim Verlassen zurueck.
 * - Klick: Wert gewaehlt (dunkler Rand), Bild bleibt, beide Produkt-Links der
 *   Karte bekommen ?variant=…, der Preis zeigt die Variante.
 * Die App nimmt Klicks aus Skripten nicht an (geprueft) - eine Auswahl laesst
 * sich also nicht an sie weitergeben. Hat jemand vor dem Laden der App
 * gewaehlt, bekommt die Karte die Klasse gz-vorab-aktiv: dann bleibt dort die
 * Vorab-Reihe stehen und die App-Reihe verborgen (mf-einheit.css).
 *
 * Nachtrag 23.09.2026 (tote Bildchen in Slidern): Der Slider des Themes
 * (component-slider.js) baut seinen Inhalt per innerHTML neu auf - beim
 * Start und bei jedem Wechsel zwischen Slider und Raster (Fenstergroesse).
 * Hatte Swatch King seine Reihe schon eingesetzt, steht danach nur noch eine
 * Kopie ohne Funktion da: kein Bildwechsel, kein Klick, der Link fuehrt zur
 * Standardvariante (gemessen: 1 von 6 Ladevorgaengen am Desktop, dazu jeder
 * Groessenwechsel). Die App zeichnet diese Karte nicht neu, solange die Kopie
 * da ist. Deshalb: Taucht eine Karte neu im Dokument auf, die schon eine
 * App-Reihe enthaelt, wird die Kopie entfernt. Bis die App neu gezeichnet hat
 * (gemessen unter 0,5 s), steht die bedienbare Vorab-Reihe da.
 *
 * Nachtrag 23.09.2026 (Entscheidung Thomas): "+N" bleibt, damit die Karten
 * nicht aufgeblaeht werden, ist aber jetzt ein Link zur Produktseite mit der
 * gerade gewaehlten Variante.
 */
(function () {
  var SEL = '.product-item > variant-swatch-king ul.swatch-view, .product-item > .gz-vorab > ul.gz-vorab__reihe';
  var PUNKTE = ':scope > li.swatch-view-item, :scope > li.gz-vorab__punkt';
  /* GRAVURZEILE 25.09.2026 (a54, Ladezeit): Kuerzen in drei Schritten -
     erst alle Reihen zuruecksetzen (schreiben), dann alle messen (lesen),
     dann alle kuerzen (schreiben). Vorher wurde je Reihe geschrieben und
     gleich gemessen: der Browser musste fuer jede Reihe das Layout neu
     berechnen (erzwungener Umbruch, Lighthouse "Forced reflow"). Ergebnis
     je Reihe unveraendert. */
  function vorbereiten(ul) {
    if (!ul || !ul.isConnected) return null;
    var alt = ul.querySelector(':scope > li.gz-swatch-mehr');
    if (alt) alt.parentNode.removeChild(alt);
    var items = [].slice.call(ul.querySelectorAll(PUNKTE));
    for (var i = 0; i < items.length; i++) items[i].style.removeProperty('display');
    if (items.length < 2) return null;
    return { ul: ul, items: items, passt: 0 };
  }
  function messen(r) {
    var breite = r.ul.clientWidth;
    if (!breite) return;
    var cs = getComputedStyle(r.ul);
    var luecke = parseFloat(cs.columnGap) || 0;
    var w = r.items[0].getBoundingClientRect().width;
    if (!w) return;
    r.passt = Math.max(1, Math.floor((breite + luecke) / (w + luecke)));
  }
  function anwenden(r) {
    var ul = r.ul, items = r.items, passt = r.passt;
    if (!passt || items.length <= passt) return;
    var zeigen = Math.max(1, passt - 1);
    for (var j = zeigen; j < items.length; j++) items[j].style.display = 'none';
    var m = document.createElement('li');
    m.className = 'gz-swatch-mehr';
    var mehr = items.length - zeigen;
    var ziel = produktLink(ul);
    if (ziel) {
      /* 23.09.2026, Wunsch Thomas: "+N" fuehrt zur Produktseite, dort sind
         alle Varianten zu sehen - mit der gerade gewaehlten Variante. */
      var a = document.createElement('a');
      a.className = 'gz-swatch-mehr__link';
      a.setAttribute('href', ziel);
      a.textContent = '+' + mehr;
      a.setAttribute('title', 'Alle ' + items.length + ' Varianten ansehen');
      a.setAttribute('aria-label', 'Alle ' + items.length + ' Varianten ansehen');
      /* Die Vorab-Reihe ist fuer Vorlesehilfen verborgen (aria-hidden):
         dort nicht per Tab erreichbar, die Reihe der App uebernimmt das. */
      if (ul.classList.contains('gz-vorab__reihe')) a.setAttribute('tabindex', '-1');
      m.appendChild(a);
    } else {
      m.setAttribute('aria-hidden', 'true');
      m.textContent = '+' + mehr;
    }
    ul.appendChild(m);
  }
  function kuerzen(ul) {
    var r = vorbereiten(ul);
    if (!r) return;
    messen(r);
    anwenden(r);
  }
  /* Ziel fuer "+N": der Produkt-Link der Karte. Nach der Wahl eines
     Bildchens traegt er ?variant=… (App oder Vorab-Reihe). */
  function produktLink(el) {
    var k = el && el.closest ? el.closest('.product-item') : null;
    if (!k) return null;
    var t = k.querySelector('a.product-item__title[href]') || k.querySelector('a[href*="/products/"]');
    return t ? t.getAttribute('href') : null;
  }
  /* Kurz vor dem Oeffnen das Ziel auffrischen - die Wahl kann sich seit dem
     Anlegen des "+N" geaendert haben. Der Klick auf "+N" geht nicht weiter an
     die App (kein Bildchen), damit sie ihn nicht abfaengt. */
  function mehrLink(e) {
    var a = e.target && e.target.closest ? e.target.closest('a.gz-swatch-mehr__link') : null;
    if (!a) return;
    var ziel = produktLink(a);
    if (ziel) a.setAttribute('href', ziel);
    if (e.type === 'click') e.stopPropagation();
  }
  ['pointerdown', 'mouseover', 'focusin', 'click'].forEach(function (typ) {
    document.addEventListener(typ, mehrLink, true);
  });
  function alle() {
    var l = document.querySelectorAll(SEL), rs = [], i;
    for (i = 0; i < l.length; i++) { try { var r = vorbereiten(l[i]); if (r) rs.push(r); } catch (e) {} }
    for (i = 0; i < rs.length; i++) { try { messen(rs[i]); } catch (e) {} }
    for (i = 0; i < rs.length; i++) { try { anwenden(rs[i]); } catch (e) {} }
  }
  var uhr = null;
  function spaeter() { if (uhr) clearTimeout(uhr); uhr = setTimeout(alle, 150); }
  function betrifft(n) {
    return n.nodeType === 1 && (n.tagName === 'VARIANT-SWATCH-KING' || n.tagName === 'UL' && n.classList.contains('swatch-view') ||
      (n.querySelector && n.querySelector('variant-swatch-king, ul.swatch-view')));
  }
  /* Nur die Reihen im neuen Knoten - nicht die ganze Seite, sonst wuerde
     bei jeder Karte der App jede Karte neu vermessen. */
  function sofort(n) {
    try {
      var l = (n.matches && n.matches(SEL)) ? [n] : (n.querySelectorAll ? n.querySelectorAll(SEL) : []);
      for (var i = 0; i < l.length; i++) {
        kuerzen(l[i]);
        /* Die App-Reihe ist da: Hing noch ein Bild vom Ueberfahren der
           Vorab-Reihe an der Karte (ohne Auswahl), zurueck zum Ausgangsbild. */
        var k = l[i].closest('.product-item');
        if (k && l[i].classList.contains('swatch-view') && !k.classList.contains('gz-vorab-aktiv')) zurueck(k);
      }
    } catch (e) {}
  }
  /* Karten, die als Ganzes neu eingefuegt wurden (Slider-Neuaufbau), duerfen
     keine App-Reihe mitbringen - das waere eine tote Kopie. Die App setzt
     ihre Reihe immer in eine schon vorhandene Karte, nie mit der Karte. */
  function kopienEntfernen(n) {
    if (n.nodeType !== 1) return;
    var karten = n.classList && n.classList.contains('product-item') ? [n] :
      (n.getElementsByClassName ? n.getElementsByClassName('product-item') : []);
    for (var i = 0; i < karten.length; i++) {
      var k = karten[i];
      if (!k.querySelector(':scope > variant-swatch-king li.swatch-view-item')) continue;
      [].forEach.call(k.querySelectorAll(':scope > variant-swatch-king'), function (v) { v.parentNode.removeChild(v); });
      k.removeAttribute('swatch-generated');
    }
  }
  try {
    new MutationObserver(function (liste) {
      var gefunden = false;
      for (var i = 0; i < liste.length; i++) {
        var neu = liste[i].addedNodes;
        for (var j = 0; j < neu.length; j++) {
          try { kopienEntfernen(neu[j]); } catch (x) {}
          if (betrifft(neu[j])) { sofort(neu[j]); gefunden = true; }
        }
      }
      if (gefunden) spaeter();
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  /* ---- Vorab-Reihe bedienbar ------------------------------------------ */
  function bilder(k) {
    return {
      a: k.querySelector('.product-item__image-figure--primary img'),
      b: k.querySelector('.product-item__image-figure--secondary img')
    };
  }
  /* Zustand steht in Attributen, nicht in JS-Eigenschaften: Der Slider der
     Startseite baut seine Karten nach dem Laden neu auf (per HTML-Kopie,
     gemessen). Attribute ueberleben das, Eigenschaften nicht. */
  function merken(k) {
    var b = bilder(k);
    ['a', 'b'].forEach(function (x) {
      var img = b[x];
      if (!img || img.hasAttribute('data-gz-src')) return;
      img.setAttribute('data-gz-src', img.getAttribute('src') || '');
      img.setAttribute('data-gz-srcset', img.getAttribute('srcset') || '');
    });
  }
  function setze(img, src, srcset) {
    if (!img || !src) return;
    img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
  }
  function zeige(k, li) {
    merken(k);
    var b = bilder(k);
    setze(b.a, li.getAttribute('data-bild'), li.getAttribute('data-bild'));
    setze(b.b, li.getAttribute('data-bild2'), li.getAttribute('data-bild2'));
  }
  function zurueck(k) {
    if (!k) return;
    var gewaehlt = k.querySelector('.gz-vorab .gz-vorab__punkt[data-gz-klick]');
    if (gewaehlt && k.classList.contains('gz-vorab-aktiv')) { zeige(k, gewaehlt); return; }
    var b = bilder(k);
    ['a', 'b'].forEach(function (x) {
      var img = b[x];
      if (!img || !img.hasAttribute('data-gz-src')) return;
      setze(img, img.getAttribute('data-gz-src'), img.getAttribute('data-gz-srcset'));
    });
  }
  function daten(k) {
    var d = null, el = k.querySelector('.gz-vorab .gz-vorab__daten');
    try { d = el ? JSON.parse(el.textContent) : null; } catch (e) { d = null; }
    return d;
  }
  function htmlText(t) {
    var s = document.createElement('span'); s.textContent = t; return s.innerHTML;
  }
  function waehle(k, li) {
    merken(k);
    var reihe = li.parentNode;
    [].forEach.call(reihe.querySelectorAll('.gz-vorab__punkt'), function (x) {
      x.classList.toggle('gz-gewaehlt', x === li);
    });
    [].forEach.call(k.querySelectorAll('.gz-vorab .gz-vorab__punkt[data-gz-klick]'), function (x) { x.removeAttribute('data-gz-klick'); });
    li.setAttribute('data-gz-klick', '');
    k.classList.add('gz-vorab-aktiv');
    zeige(k, li);

    /* Variante: bei mehreren Reihen die Kombination aller gewaehlten Werte */
    var d = daten(k), wahl = {}, treffer = null;
    [].forEach.call(k.querySelectorAll('.gz-vorab .gz-vorab__punkt.gz-gewaehlt'), function (x) {
      wahl[+x.getAttribute('data-pos') - 1] = x.getAttribute('data-wert');
    });
    if (d && d.v) {
      for (var i = 0; i < d.v.length && !treffer; i++) {
        var ok = true;
        for (var pos in wahl) { if (d.v[i][1][pos] !== wahl[pos]) { ok = false; break; } }
        if (ok) treffer = d.v[i];
      }
      if (!treffer) {
        for (var j = 0; j < d.v.length; j++) { if (String(d.v[j][0]) === li.getAttribute('data-variante')) { treffer = d.v[j]; break; } }
      }
    }
    var id = treffer ? String(treffer[0]) : li.getAttribute('data-variante');
    /* Wie die App: in jeder Reihe den Wert der gefundenen Variante markieren
       (Geburtstagskerze: Klick auf "Rosa" markiert auch "Kleine Kerze"). */
    if (treffer) {
      [].forEach.call(k.querySelectorAll('.gz-vorab .gz-vorab__punkt'), function (x) {
        var pos = +x.getAttribute('data-pos') - 1;
        x.classList.toggle('gz-gewaehlt', treffer[1][pos] === x.getAttribute('data-wert'));
      });
    }

    /* Links der Karte wie die App: ?variant=… */
    [].forEach.call(k.querySelectorAll('a[href*="/products/"]'), function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        u.searchParams.set('variant', id);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });

    /* Preis der Variante, im Aufbau von snippets/product-price.liquid */
    var p = k.querySelector('.product-item__price .product-price');
    if (p && treffer && d.l) {
      var h = '<span class="product-price--original"><span class="visually-hidden">' + htmlText(d.l[0]) + '</span>' + htmlText(treffer[2]) + '</span>';
      if (treffer[3]) h += '<del class="product-price--compare"><span class="visually-hidden">' + htmlText(d.l[1]) + '</span><span style="text-decoration: line-through;">' + htmlText(treffer[3]) + '</span></del>';
      p.innerHTML = h;
    }
  }
  function punkt(e) {
    var t = e.target;
    return t && t.closest ? t.closest('.product-item > .gz-vorab .gz-vorab__punkt') : null;
  }
  document.addEventListener('mouseover', function (e) {
    var li = punkt(e); if (!li) return;
    var von = e.relatedTarget; if (von && li.contains(von)) return;
    try { zeige(li.closest('.product-item'), li); } catch (x) {}
  });
  document.addEventListener('mouseout', function (e) {
    var li = punkt(e); if (!li) return;
    var nach = e.relatedTarget; if (nach && li.contains(nach)) return;
    try { zurueck(li.closest('.product-item')); } catch (x) {}
  });
  document.addEventListener('click', function (e) {
    var li = punkt(e); if (!li) return;
    e.preventDefault();
    try { waehle(li.closest('.product-item'), li); } catch (x) {}
  });

  window.addEventListener('resize', spaeter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  window.addEventListener('load', spaeter);
})();
